export function isTolinkLogin(): boolean {
    const token = sessionStorage.getItem("tolink_token")
    return token && token != null && token.length > 0
}

